module.exports = __webpack_public_path__ + "img/seriously_fun_graphic.b73da9a1.png";